<section [formGroup]="form">
  @if (showTitle) {
    <h3 class="py-2 text-sm font-semibold">{{ 'connectionRight.title' | translate }}</h3>
  }

  @if (isExpired) {
    <app-alert type="warning" [closeable]="false">
      {{ 'connectionRight.expiredWarning' | translate }}
    </app-alert>
  }

  <div [class.opacity-50]="isExpired">
    <app-input-group>
      <label appLabel>{{ 'connectionRight.maximumPower' | translate }}</label>
      <input appInputNumber formControlName="maximumPower" [decimals]="1" min="0" append="kW">
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'connectionRight.maximumCurrent' | translate }}</label>
      <input appInputNumber formControlName="maximumCurrent" min="0" append="A">
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'connectionRight.limitedGridAccess' | translate }}</label>
      <input appInputNumber formControlName="limitedGridAccess" [decimals]="1" min="0" append="kW">
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'connectionRight.limitedGridAccessCurrent' | translate }}</label>
      <input appInputNumber formControlName="limitedGridAccessCurrent" min="0" append="A">
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'connectionRight.validFrom' | translate }}</label>
      <input appInputDate type="date" [defaultDate]="false" [max]="maximumValidFrom" formControlName="validFrom">
      @if (form.controls.validFrom.errors?.['invalidDate'] && form.controls.validFrom.touched) {
        <p class="text-red-600 text-sm">{{ 'connectionRight.invalidDate' | translate }}</p>
      }
      @if (form.controls.validFrom.errors?.['futureDate'] && form.controls.validFrom.touched) {
        <p class="text-red-600 text-sm">{{ 'connectionRight.futureDate' | translate }}</p>
      }
      @if (form.controls.validFrom.errors?.['earlierDate'] && form.controls.validFrom.touched) {
        <p class="text-red-600 text-sm">{{ 'connectionRight.earlierDate' | translate }}</p>
      }
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'connectionRight.comment' | translate }}</label>
      <textarea appInput rows="3" formControlName="comment"></textarea>
    </app-input-group>
  </div>
</section>
